export const errorConstants = {
    LINK_INVALIDO: 2,
    ERROR_GENERICO: 1,
    NO_CONTROLADO:3,
    SESION_VENCIDA:4,
    CONTRASENIA_INCORRECTA:5
};
